export default __webpack_public_path__ + "static/oops-0c4fa302fff6232318b6e37962e0d0b4.svg";